
document.documentElement.classList.replace('no-js', 'js');
// Init Navigation

init();

function init() {
    initNavigation();
}

// =====================
// Navigation (Hamburger Burger)
// =====================
function initNavigation() {
    const root = document.documentElement;
    root.classList.add("js");

    const toggleButton = document.querySelector(".menu-toggle");
    const nav = document.getElementById("main-nav");

    if (!toggleButton || !nav) return;

    const firstLink = nav.querySelector("a");

    function openMenu() {
        nav.classList.add("is-open");
        toggleButton.setAttribute("aria-expanded", "true");
        toggleButton.setAttribute("aria-label", "Hauptnavigation schliessen");
        firstLink?.focus();
    }

    function closeMenu({ returnFocus = true } = {}) {
        nav.classList.remove("is-open");
        toggleButton.setAttribute("aria-expanded", "false");
        toggleButton.setAttribute("aria-label", "Hauptnavigation öffnen");

        if (returnFocus) {
            toggleButton.focus();
        }
    }

    toggleButton.addEventListener("click", () => {
        const isOpen = toggleButton.getAttribute("aria-expanded") === "true";
        isOpen ? closeMenu() : openMenu();
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            const isOpen = toggleButton.getAttribute("aria-expanded") === "true";
            if (isOpen) closeMenu();
        }
    });
}


// Slider
document.addEventListener("DOMContentLoaded", function () {
    const slides = document.querySelectorAll(".slide");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");
    const pauseBtn = document.getElementById("pauseBtn");

    if (slides.length === 0) return;

    let currentIndex = 0;
    let slideInterval;
    let isPaused = false;
    const intervalTime = 5000; // 5000 Millisekunden = 5 Sekunden pro Bild

    // Funktion zum Anzeigen eines bestimmten Bildes
    function showSlide(index) {
        // Aktuelles Bild verstecken
        slides[currentIndex].classList.remove("active");
        slides[currentIndex].setAttribute("aria-hidden", "true");

        // Index berechnen (springt am Ende wieder zum Anfang und umgekehrt)
        currentIndex = (index + slides.length) % slides.length;

        // Neues Bild anzeigen
        slides[currentIndex].classList.add("active");
        slides[currentIndex].setAttribute("aria-hidden", "false");
    }

    function nextSlide() { showSlide(currentIndex + 1); }
    function prevSlide() { showSlide(currentIndex - 1); }

    // Timer starten
    function startAutoPlay() {
        if (!isPaused) {
            slideInterval = setInterval(nextSlide, intervalTime);
        }
    }

    // Timer zurücksetzen (wichtig, wenn der Nutzer manuell klickt)
    function resetAutoPlay() {
        clearInterval(slideInterval);
        startAutoPlay();
    }

    // Event Listener für Zurück / Weiter
    prevBtn.addEventListener("click", () => {
        prevSlide();
        resetAutoPlay();
    });

    nextBtn.addEventListener("click", () => {
        nextSlide();
        resetAutoPlay();
    });

    // Event Listener für Pause / Play
    pauseBtn.addEventListener("click", () => {
        isPaused = !isPaused;
        pauseBtn.setAttribute("aria-pressed", isPaused);
        pauseBtn.innerHTML = isPaused ? "▶ Play" : "⏸ Pause";

        if (isPaused) {
            clearInterval(slideInterval);
        } else {
            startAutoPlay();
        }
    });

    // Barrierefreiheit: Initiales Setzen der ARIA-Attribute
    slides.forEach((slide, index) => {
        slide.setAttribute("aria-hidden", index === 0 ? "false" : "true");
    });

    // Animation respektieren (falls Nutzer Bewegungen im Betriebssystem deaktiviert hat)
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReducedMotion) {
        startAutoPlay();
    } else {
        // Wenn reduziert gewünscht ist, setzen wir es direkt auf Pause
        isPaused = true;
        pauseBtn.setAttribute("aria-pressed", "true");
        pauseBtn.innerHTML = "▶ Play";
    }
});

// Service Worker Registrierung für PWA (Progressive Web App)
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        import("virtual:pwa-register").then(({ registerSW }) => {
            registerSW({ immediate: false });
        });
    });
}
